import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

const TABS = [
  {
    label: 'SFTP',
    testId: 'connectivitySftpTab',
    to: '/connectivity/sftp',
    value: 'sftp'
  },
  {
    label: 'MAP Providers',
    testId: 'connectivityMapProvidersTab',
    to: '/connectivity/map-providers',
    value: 'map-providers'
  },
  {
    label: 'Misc',
    testId: 'connectivityMiscTab',
    to: '/connectivity/misc',
    value: 'misc'
  }
] as const;

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate({ from: Route.fullPath });

  const tab =
    TABS.find(item => location.pathname.startsWith(item.to))?.value ??
    'record-keepers';

  const onRecordKeepersTab = () => navigate({ to: '/connectivity' });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Connectivity</Typography>

      <Tabs value={tab}>
        <Tab
          data-testid='connectivityRecordKeepersTab'
          label='Record Keepers'
          onClick={onRecordKeepersTab}
          value='record-keepers'
        />
        {TABS.map(item => (
          <Tab
            data-testid={item.testId}
            key={item.value}
            label={item.label}
            onClick={() => navigate({ to: item.to })}
            value={item.value}
          />
        ))}
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/connectivity')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: Layout
});
